import React from "react";
import { styled } from "../../stitches.config";

import Link from "../Link";
import ArticleLinks from "./ArticleLinks";

import PlayIcon from "../../assets/img/play.svg";
import Dwukropek from "../../assets/img/natemat/dots_orange.svg";
import CommentImage from "../../assets/img/comment_gray.svg";
import FacebookImage from "../../assets/img/facebook_round_gray.svg";
import KulkiSvg from "./KulkiSvg";
import Youtube from "../Article/Parts/Youtube";
import OnnetworkPlayer from "../OnnetworkPlayer";
import Media from "./Media"

// jak się przełączy na lazy, to edytor w BO nie działa
import { EmbeddedVideo } from "react-facebook";
// const EmbeddedVideo = React.lazy(() => import(/* webpackChunkName: "react-facebook" */"react-facebook").then(m => ({ default: m.EmbeddedVideo })));

const TextOnPicture = props => {
  const { article, aspectRatio: { mobile = 1.78, desktop = 1.67 } = {} } = props;
  const isDesktop = window.innerWidth > 992;
  const partner = (article.partner ? <Partner>{article.partner}</Partner> : null);
  const label = (article.label ? <Label>{article.label}</Label> : null);
  const player = (parseInt(article.player) === 1 ? <Player /> : null);

  var imageHeight = (props.imageHeight ? props.imageHeight : (window.innerWidth > 991 ? 520 : 375));
  var imageWidth = 0;

  // if (props.preserveImageRatio && window.innerWidth > 991) {
  //   imageHeight = 0;
  //   imageWidth = 1170;
  // }
  var imgUrl = article.picture.img || '/';
  imgUrl = imgUrl.replace("780,0,0,0", `${imageWidth},${imageHeight},0,0`);

  var stats = [];
  if (article.stats && article.stats.shares) {
    stats.push(<Likes key='fb-shares'><img src={FacebookImage} alt="" /><span data-facebook-stats> {article.stats.shares}</span></Likes>);
  }
  if (article.stats && article.stats.comments) {
    stats.push(<Likes key='fb-likes'><img src={CommentImage} alt="" /><span data-comments-stats> {article.stats.comments}</span></Likes>);
  }

  var partnerLogo = null;
  if (article.partner_logo) {
    var partnerLogoImg = window.MEDIA_DOMAIN + '/' + article.partner_logo.replace('.', ',90,90,0,0.');
    partnerLogo = (
      <ArticlePartner>
        Partnerem materiału jest
        <img src={partnerLogoImg} alt="" />
      </ArticlePartner>
    );
  }

  var embed = null;
  if (article.embed && article.embed.type) {
    if (article.embed.type === 'youtube') {
      embed = <EmbedElement size={props.size}>
        <Youtube videoId={article.embed.id} />
      </EmbedElement>
    } else if (article.embed.type === 'onnetwork') {
      embed = <EmbedElement size={props.size}>
        <div className="top--embed-onnetwork">
          <OnnetworkPlayer
            mid={article.embed.mid}
          />
        </div>
      </EmbedElement>
    } else if (article.embed.type === 'facebook') {
      embed = <EmbedElement size={props.size}>
        <div className="top--embed--facebook">
          <EmbeddedVideo href={article.embed.url} />
        </div>
      </EmbedElement>
    }
  }

  const aspectRatio = isDesktop ? desktop : mobile;

  return (
    <BoxWrapper
      className="text-on-picture"
      css={{
        "$$bg": imgUrl,
        "$$imageHeight": imageHeight + 'px'
      }}
      preserveImageRatio={props.preserveImageRatio}
      isEmbed={!!embed}>
      <Link to={article.url}>
        <ImageWrapper>
          {embed ?
            null :
            <Media
              media={props.media}
              src={article.picture.img}
              preserveRatio={props.preserveImageRatio ? true : false}
              aspectRatio={props.preserveImageRatio ? undefined : aspectRatio} />}
          {player}
          {embed}
          {label}
          {partner}
          {partnerLogo}
        </ImageWrapper>
      </Link>

      {!!embed || <Footer className={article.show_links && article.show_links !== 'off' ? 'show-links' : null} size={props.size} isEmbed={!!embed}>
        {/* 5805 */}
        {/* <Stats data-stat-furl={article.url}>{stats}</Stats> */}
        <Title className="text-on-picture__title" size={props.size}>
          <KulkiSvg />
          {article.title}
        </Title>
        <ArticleLinks links={article.links} show={article.show_links} />
      </Footer>}
    </BoxWrapper>
  );
};

const Title = styled("span", {
  color: "#FFFFFF",
  fontSize: "30px",
  letterSpacing: "-0.32px",
  lineHeight: "30px",
  display: "block",
  position: "relative",
  pointerEvents: "none",
  "> svg": {
    display: "block",
    position: "absolute",
    top: "-11px",
    left: "-39px",
    height: "48px",
    width: "22px",
    "@media (max-width: 992px)": {
      display: "none"
    }
  },
  variants: {
    "size":{
      "sm":{
        "@media (min-width: 992px)":{
          fontSize: "15px",
          lineHeight: "18px",
          "& > svg":{
            display: "none"
          }
        }
      }
    }
  }
});

const BoxWrapper = styled("div", {
  margin: "12px 0",
  position: "relative",
  height: "auto",
  overflow: "hidden",
  minHeight: "$$imageHeight",
  paddingBottom: "0",
  display: "flex",
  "& > a": {
    display: "block",
    textDecoration: "none",
    position: "absolute",
    zIndex: 1,
    inset: 0,
    minWidth: "100%",
    "@media (min-width: 992px)": {
      position: "absolute"
    }
  },
  "circle": {
    transition: "all 0.2s linear"
  },
  "&:hover": {
    [`& ${Title}`]: {
      color: "$primary",
      textDecoration: "none",
      cursor: "pointer",
      "circle": {
        fill: "#000",
        stroke: "#000"
      }
    }
  },
  "@media (min-width: 992px)": {
    paddingBottom: 0
  },
  variants: {
    "isEmbed": {
      true: {
        minHeight: "100px",
        paddingBottom: "53%"
      },
      false: {}
    },
    "preserveImageRatio": {
      true: {
        "& > a": {
          "@media (min-width: 992px)": {
            position: "static"
          }
        }
      },
      false: {}
    }
  }
});

const ImageWrapper = styled("div", {
  height: "100%",
  "img": {
    width: "100%",
    height: "auto",
    minHeight: "100%",
    display: "block",
    objectFit: "cover"
  },
  "> .preserveImageRatioImage": {
    display: "none"
  },
  "@media (min-width: 992px)": {
    display: "block",
    "> .preserveImageRatioImage": {
      width: "100%",
      display: "none",
      minHeight: "$$imageHeight"
    }
  },
  variants: {
    "preserveImageRatio": {
      true: {
        "@media (min-width: 992px)": {
          "> .preserveImageRatioImage": {
            display: "block",
            minHeight: "150px"
          }
        }
      },
      false: {}
    }
  }
});

const EmbedElement = styled("span", {
  display: "block",
  position: "static",
  left: "0",
  top: "0",
  right: "0",
  bottom: "0",
  ".top--embed--facebook": {
    padding: "0 15px",
    backgroundColor: "black"
  },
  ".part--youtube-video, .onnetwork-video": {
    margin: "0",
    paddingTop: "0",
    paddingBottom: "52%",
    backgroundColor: "black"
  },
  "@media (min-width: 992px)": {
    backgroundColor: "black",
    ".top--embed--facebook, .part--youtube-video": {
      height: "auto"
    },
  }
});

const Label = styled("span", {
  display: "block",
  position: "absolute",
  left: "30px",
  top: "30px",
  padding: "0px 10px",
  background: "$primary",
  color: "white",
  lineHeight: "22px",
  fontSize: "15px",
  fontWeight: 500,
  zIndex: 4
});

const Partner = styled("span", {
  display: "block",
  position: "absolute",
  left: "0",
  top: "0",
  padding: "0px 8px",
  backgroundColor: "#D8D8D8",
  color: "#8B8B8B",
  lineHeight: "16px",
  fontSize: "11px",
  zIndex: 4
});
const Player = styled("span", {
  display: "block",
  position: "absolute",
  left: "0",
  bottom: "0",
  right: "0",
  top: "0",
  background: `transparent url("${PlayIcon}") no-repeat center center`,
  backgroundSize: "105px auto",
  zIndex: 5
});

const Stats = styled("span", {
  display: "block",
  margin: "0 0 6px 0"
  /* przenosze, bo było w prawym górnym rogu, ale tam jest logo partnera
  position: absolute;
  right: 10px;
  top: 10px;
  */
  /* box-shadow: -1px 0px 14px 0px rgba(0,0,0,0.86); */
});

const ArticlePartner = styled("span", {
  fontSize: "10px",
  color: "#eee",
  position: "absolute",
  right: "10px",
  top: "10px",
  "img": {
    width: "40px",
    marginLeft: "6px"
  }
});

const Likes = styled("span", {
  display: "inline-block",
  padding: "0 10px 0 0",
  color: "#fff",
  fontSize: "10px",
  fontWeight: 500,
  "img": {
    width: "12px",
    paddingRight: "2px"
  }
});

const Footer = styled("span", {
  display: "block",
  alignSelf: "flex-end",
  background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 100%)",
  padding: "70px 15px 35px 15px",
  position: "relative",
  zIndex: 2,
  pointerEvents: "none",
  width: "100%",
  "@media (min-width: 992px)": {
    position: "absolute",
    left: "0",
    bottom: "0",
    right: "0",
    padding: "50px 30px 48px 65px",
    "&.show-links": {
      paddingLeft: "250px"
    },
    "&.show-links--on-right": {
      display: "flex",
      alignItems: "flex-end",
      padding: "50px 30px 48px 65px"
    }
  },
  variants: {
    "isEmbed": {
      true: {
        position: "absolute",
        bottom: 0
      },
      false: {}
    },
    "size": {
      "sm": {
        "@media (min-width: 992px)": {
          padding: '0 15px 35px 15px'
        }
      }
    }
  }
});

export default TextOnPicture;
